// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2yu3E","icon":"SortAdornment_icon__1ZR1A","up":"SortAdornment_up__2SL9F","down":"SortAdornment_down__2XTJk","active":"SortAdornment_active__1uoqQ"};